import {http} from "../http";

export interface Commission {
    PAYMENT_TYPE : string;
    CIF : string;
    CUSTACC : string;
    AMOUNT : string;
    CUR : string;
    BENEFBANKCODE : string;
    BENEFACC : string;
    BENEFTAXID : string;
    PMTDET : string;
}

export const getCustomerCommission = async (request_data: Commission): Promise<Commission> => {
    let request_data_temp={
        "PAYMENT_TYPE": request_data.PAYMENT_TYPE,
        "CIF": request_data.CIF,
        "CUSTACC": request_data.CUSTACC,
        "AMOUNT": request_data.AMOUNT,
        "CUR": request_data.CUR,
        "BENEFBANKCODE": request_data.BENEFBANKCODE,
        "BENEFACC": request_data.BENEFACC,
        "BENEFTAXID": request_data.BENEFTAXID,
        "PMTDET": request_data.PMTDET ?? ''
    };
    const { data } = await http.post<Commission>("moneytransfer/getcustomercommision", request_data_temp);
    return data;
};
